import { Tooltip } from "../../../../../../../components/tooltip";
import { CopyToClipboard } from "../../../../../../../components";

import styles from "../info.module.scss";

type Props = {
  originList: string[];
};

const FileOriginList = ({ originList }: Props) => (
  <>
    {!!originList.length && (
      <Tooltip
        variant="interactive"
        content={originList.map(origin => (
          <div className="flex flex-center gap-sm" key={origin}>
            <div className="overflow-ellipsis">{origin}</div>
            <CopyToClipboard value={origin} />
            <br></br>
          </div>
        ))}
      >
        <span className={styles.dashed_underline}>/.../</span>
      </Tooltip>
    )}
  </>
);

export default FileOriginList;
